import { Component, input, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'vb-lxp-bar-gauge',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './bar-gauge.component.html',
	styleUrls: ['./bar-gauge.component.css'],
})
export class BarGaugeComponent implements OnChanges {
	label = input('');

	value = input(0);

	min = input(0);

	max = input(100);

	/** Fill colour — any valid CSS colour string or M3 variable */
	@Input() color: string = 'var(--primary)';
	opacity = input(1);

	fillPercent: number = 0;

	ngOnChanges(_: SimpleChanges): void {
		const clamped = Math.min(this.max(), Math.max(this.min(), this.value()));
		const range = this.max() - this.min() || 1;
		this.fillPercent = ((clamped - this.min()) / range) * 100;
	}
}
